import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Permisos from "../../../views/administrador/Permisos/Permisos";


const Administrador = () => {
    return (
        <Routes>
            {/* registro visitantes */}
            <Route exact path="/administrador/permisos" element={<Suspense fallback={<>skeleton</>}>
                <Permisos></Permisos>
            </Suspense>} />
        </Routes>
    )
}
export default Administrador